<div class="p-p-4">
    <p-card *ngIf="callbackIsValid; else invalidCallback">
        <ng-template pTemplate="header">
            <div class="p-text-center p-pt-2">
                <h2>
                    {{logService.selectedLog?.name}}
                </h2>
                <h3>Shift sign on</h3>
            </div>
            <p-divider></p-divider>
        </ng-template>
        <ng-template pTemplate="body">
            <ng-container *ngIf="showSignOn; else alreadyOnShift">
                <shift-sign-on #shiftSignOnComponent (signOnCompleted)="sendCallback($event, true)"></shift-sign-on>
            </ng-container>
        </ng-template>
    </p-card>
</div>

<ng-template #alreadyOnShift>
    <div class="p-text-center">
        <h4>
            You are already on shift {{shiftService.activeShifts[0]?.role?.name ?? ''}}
        </h4>
    </div>
</ng-template>

<ng-template #invalidCallback>
    <div class="p-text-center">
        <h4>
            The callback URL is invalid
        </h4>
    </div>
</ng-template>
